import { render, staticRenderFns } from "./BetgameEditSpecialQuestionAnswer.vue?vue&type=template&id=1e8b3270&scoped=true"
import script from "./BetgameEditSpecialQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./BetgameEditSpecialQuestionAnswer.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditSpecialQuestionAnswer.vue?vue&type=style&index=0&id=1e8b3270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b3270",
  null
  
)

export default component.exports